<template>
  <section id="login">
    <div class="login-container">
      <AuthForm v-if="authLink"/>
      <LoginForm v-else/>
    </div>
  </section>
</template>

<script>
import LoginForm from './components/LoginForm'
import AuthForm from './components/AuthForm'
import {mapActions, mapGetters} from 'vuex'

const fb = require('@/core/config/firebase.js');

export default {
  name: 'Login',
  metaInfo: {
    title: 'Login',
  },
  components: {
    AuthForm,
    LoginForm,
  },
  props: {
    redirectPath: {
      type: [ Object, String ]
    }
  },
  computed: {
    ...mapGetters('user', ['getCurrentUser', 'getUserProfile']),
  },
  data() {
    return {
      authLink: false,
    }
  },
  watch: {
    getCurrentUser(newValue) {
      if (!newValue || this.authLink)
        return;

      this.handleUserLoggingIn()
    }
  },
  methods: {
    ...mapActions('user', ['waitForProfile']),

    async handleUserLoggingIn() {

      if (this.getCurrentUser === 'verifying') {
        await this.waitForProfile();
      }

      if(!this.redirectPath) {
        this.$router.push('/');
      } else {
        this.$router.push(this.redirectPath)
      }
    }
  },
  mounted() {
    if (fb.auth.isSignInWithEmailLink(window.location.href))
      this.authLink = true;
  }
}
</script>
<style>
.login-container {
  height: 100%;
}
</style>
